
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/czesci-auta-dostawcze/[tytul]/[shortid]/[lang]",
      function () {
        return require("private-next-pages/czesci-auta-dostawcze/[tytul]/[shortid]/[lang]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/czesci-auta-dostawcze/[tytul]/[shortid]/[lang]"])
      });
    }
  